"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInspectionTimesDto = instanceOfInspectionTimesDto;
exports.InspectionTimesDtoFromJSON = InspectionTimesDtoFromJSON;
exports.InspectionTimesDtoFromJSONTyped = InspectionTimesDtoFromJSONTyped;
exports.InspectionTimesDtoToJSON = InspectionTimesDtoToJSON;
exports.InspectionTimesDtoToJSONTyped = InspectionTimesDtoToJSONTyped;
/**
 * Check if a given object implements the InspectionTimesDto interface.
 */
function instanceOfInspectionTimesDto(value) {
    if (!('inspectionStartTime' in value) || value['inspectionStartTime'] === undefined)
        return false;
    if (!('inspectionEndTime' in value) || value['inspectionEndTime'] === undefined)
        return false;
    return true;
}
function InspectionTimesDtoFromJSON(json) {
    return InspectionTimesDtoFromJSONTyped(json, false);
}
function InspectionTimesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'inspectionStartTime': json['inspectionStartTime'],
        'inspectionEndTime': json['inspectionEndTime'],
    };
}
function InspectionTimesDtoToJSON(json) {
    return InspectionTimesDtoToJSONTyped(json, false);
}
function InspectionTimesDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'inspectionStartTime': value['inspectionStartTime'],
        'inspectionEndTime': value['inspectionEndTime'],
    };
}
